// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { setPricingManagementSelectedPricingGroupDef } from 'redux/modules/pricingManagement/actions'

const togglePricingManagementSelectedPricingGroupDef = uniqueKey => (dispatch, getState) => {
  const { selectedPricingGroupDef } = getState().pricingManagement

  const newValue = selectedPricingGroupDef === uniqueKey ? null : uniqueKey

  // save highlighted uniqueKey to redux
  dispatch(setPricingManagementSelectedPricingGroupDef(newValue))
}

export default togglePricingManagementSelectedPricingGroupDef
